// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"5f395078","256":"c6424c03","295":"eb8ea3e0","427":"773ddfe7","596":"e7e405d7","629":"45810578","634":"81a4ff8b","706":"d768a2fc","906":"6a5919e0","952":"139b8bfd"}[chunkId] + ".chunk.js";
};